import { forwardRef } from 'react';
import type { ComponentPropsWithoutRef, ElementRef } from 'react';
import { OwcTableHeader } from '@one/react';

export type PocTableHeaderProps = ComponentPropsWithoutRef<typeof OwcTableHeader>;

export const PocTableHeader = forwardRef<ElementRef<typeof OwcTableHeader>, PocTableHeaderProps>((props, ref) => (
    <OwcTableHeader ref={ref} {...props} />
));

PocTableHeader.displayName = 'PocTableHeader';
